// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['ht_HT']  = { // eslint-disable-line import/no-commonjs
  name: 'ht_HT',
  day: {
    abbrev: ['dim', 'len', 'mad', 'mèk', 'jed', 'van', 'sam'],
    full: ['dimanch', 'lendi', 'madi', 'mèkredi', 'jedi', 'vandredi', 'samdi']
  },
  month: {
    abbrev: [
      'jan',
      'fev',
      'mas',
      'avr',
      'me',
      'jen',
      'jiy',
      'out',
      'sep',
      'okt',
      'nov',
      'des'
    ],
    full: [
      'janvye',
      'fevriye',
      'mas',
      'avril',
      'me',
      'jen',
      'jiyè',
      'out',
      'septanm',
      'oktòb',
      'novanm',
      'desanm'
    ]
  },
  meridiem: ['', ''],
  date: '%d-%m-%Y',
  time24: '%R',
  dateTime: '%a, %d %b %Y %H:%M:%S %z',
  time12: '',
  full: '%b %-d, %Y %H:%M'
}

